import { Component, OnInit } from '@angular/core';
import Urlbox from 'urlbox';

@Component({
  selector: 'app-imageprocess',
  templateUrl: './imageprocess.component.html',
  styleUrls: ['./imageprocess.component.css']
})
export class ImageprocessComponent implements OnInit {


imgUrl = '';
  constructor() {
    console.log(Date.now());
   const urlbox = Urlbox('71sCufu8lhEwU3D9', '6eec114784cf4b82b16e8a7f695cd49a');

 const options = {
  url: 'github.com',
  width: 1024,
  format: 'jpg',
  quality: 80,
  ttl:108000
};
    this.imgUrl = urlbox.buildUrl(options);
     console.log(Date.now());
   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/imageprocess/imageprocess.component.ts